import React from "react";
import { FaLock, FaBullhorn } from "react-icons/fa";

// Floating status capsule — the one always-visible answer to "can I vote
// right now?". Your team's turn: green call-to-action. Another team's turn:
// dark locked capsule naming whose turn it is; tapping any locked control
// shakes it (flashKey re-triggers the CSS animation) so the "why can't I
// press this" moment answers itself.
const TurnCapsule = ({ state, identity, canVote, flashKey }) => {
  const teams = state?.teams || [];
  const turnTeam = teams.find(
    (t) => String(t.id) === String(state?.turnTeamId)
  );
  const myTeam = teams.find((t) => String(t.id) === String(identity?.teamId));
  const relevant =
    state?.screen === "board" ||
    state?.screen === "question" ||
    state?.screen === "answer" ||
    state?.screen === "whoAnswered";
  if (!relevant || !turnTeam) return null;

  return (
    <div
      className="fixed bottom-3 left-1/2 -translate-x-1/2 z-50 pointer-events-none"
      style={{ direction: "rtl" }}
    >
      {canVote ? (
        <div className="flex items-center gap-2 bg-success text-white font-bold rounded-full px-4 py-2 shadow-2xl border-2 border-white/60 text-sm md:text-base">
          <FaBullhorn className="animate-pulse" />
          <span>دوركم يا فريق {myTeam?.name} — صوّتوا الآن!</span>
        </div>
      ) : (
        <div
          key={flashKey}
          className={`flex items-center gap-2 bg-[#1e2d4ae6] text-white rounded-full px-4 py-2 shadow-2xl border-2 border-white/30 text-sm md:text-base ${
            flashKey ? "capsule-flash" : ""
          }`}
        >
          <FaLock className="text-mainText" />
          <span>
            دور فريق <b className="text-mainText">{turnTeam.name}</b> — التصويت
            لهم الآن
          </span>
          {myTeam && (
            <span className="bg-white/15 rounded-full px-2 py-0.5 text-xs">
              فريقك: {myTeam.name}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default TurnCapsule;
